/**
 * @generated SignedSource<<34824011956e42a6b349d883f80a98ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Order_charge$data = {
  readonly id: string;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_charge">;
  readonly " $fragmentType": "Order_charge";
};
export type Order_charge$key = {
  readonly " $data"?: Order_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"Order_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Order_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Payment_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "5fb949919b43ef6823247dace1574724";

export default node;
